import { SecurityContextTemplate, SecurityContextCommonProps } from 'framework/authorization';
import { useServiceCatalogService } from 'domain/shared/serviceCatalog';

const ServiceBudgetContext = ({ permissionToCheck, children }: SecurityContextCommonProps) => {
  const { getBudgetPermissions } = useServiceCatalogService() as any;

  return (
    <SecurityContextTemplate
      getPermissionsFunc={getBudgetPermissions}
      permissionToCheck={permissionToCheck}
      contextName="ServiceBudget"
    >
      {children}
    </SecurityContextTemplate>
  );
};

export default ServiceBudgetContext;
